export default {
  namespaced: true,
  state: {
    Claims: [],
    ManagedClaims: [],
    IsBusy: true
  },
  actions: {
    initializeClaims (context, values) {
      context.commit('INITIALIZE_CLAIMS', values)
    },
    initializeManagedClaims (context, values) {
      context.commit('INITIALIZE_MANAGED_CLAIMS', values)
    }
  },
  mutations: {
    INITIALIZE_CLAIMS (state, result) {
      state.Claims = getAsArray(result)
      state.IsBusy = false
    },
    INITIALIZE_MANAGED_CLAIMS (state, result) {
      state.ManagedClaims = getAsArray(result)
      state.IsBusy = false
    }
  },
  getters: {
    getClaimList: (state) => category => {
      const claims = category === 'managedclaims' ? state.ManagedClaims : state.Claims
      if (!claims) {
        return
      }
      return claims.map(function (claim) {
        return {
          Id: claim.Id,
          ClaimType: claim.ClaimType,
          ClaimStatusTitle: claim.ClaimStatusTitle,
          DocumentsComplete: claim.DocumentsComplete,
          PassengersComplete: claim.PassengersComplete,
          CanSubmitExtraCostsClaim: claim.CanSubmitExtraCostsClaim,
          leadGenerator: claim.LeadGeneratorId,
          ReferenceNumber: claim.ReferenceNumber,
          FlightCode: claim.AirlineCode + claim.FlightNumber,
          DepartureAirport: claim.DepartureAirport,
          DepartureFlightDateTime: claim.DepartureFlightDateTime,
          ArrivalAirport: claim.ArrivalAirport,
          ArrivalFlightDateTime: claim.ArrivalFlightDateTime,
          IncidentType: claim.IncidentType,
          ParentClaimId: claim.ParentClaimId,
          passengers: getAsArray(claim.Passengers.Person).map(function (p) {
            return { id: p.Id, name: p.FirstName + ' ' + p.LastName }
          }),
          openTasks: getAsArray(claim.UnperformedDocumentActions.DocumentAction)
            .filter(da => da !== 'RequestApproveAddressChange')
        }
      })
    },
    allClaims: state => {
      return state.Claims.concat(state.ManagedClaims)
    },
    hasManagedClaims: state => state.ManagedClaims.length,
    getChildClaims: (state, getters) => id => {
      return getters.allClaims.filter(c => c.ParentClaimId === id)
    },
    getClaimById: (state, getters) => id => {
      return getters.allClaims.find(c => c.Id === id)
    },
    isManagedClaim: state => id => {
      return !!state.ManagedClaims.find(c => c.Id === id)
    },
    checkForDossier: (state, getters) => {
      return !(state.Claims.length || getters.hasManagedClaims)
    },
    getIsBusy: state => {
      return state.IsBusy
    }
  }
}

function getAsArray (objectOrArray) {
  return Array.isArray(objectOrArray) ? objectOrArray : (objectOrArray ? [objectOrArray] : [])
}
